import React from 'react';
import { Modal } from 'antd';
import cn from 'classnames';
import Task from '../../Task/Task';
import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter';
import { useCalendarState } from '../../../context/CalendarContext';
import styles from '../CalendarGrid.module.scss';
import commonStyles from '../../../Calendar.module.scss';

const TasksModal = ({ onCancel, afterClose, taskName = 'tasks' }) => {
  const { tasksModalVisible, tasksModalData } = useCalendarState();

  return (
    <Modal
      title={
        Boolean(tasksModalData) &&
        `${capitalizeFirstLetter(tasksModalData.day.format('dddd, D MMMM'))}`
      }
      visible={tasksModalVisible}
      footer={null}
      onCancel={onCancel}
      wrapClassName={styles.modal}
      afterClose={afterClose}
      zIndex="999"
    >
      {Boolean(tasksModalData) &&
        tasksModalData[taskName]
          .filter((task) => task.visible)
          .map((task) => (
            <Task
              key={task.id}
              task={task}
              rootClassName={cn(
                commonStyles[`checkbox-${task.index}`],
                'task',
                'modalTask'
              )}
              isModal
              style={{ maxHeight: '56px' }}
            />
          ))}
    </Modal>
  );
};

export default TasksModal;
